import React from 'react';

import { List } from '@fastlessjs/backoffice-layer/dist/components/templates';
import debug from '@fastlessjs/backoffice-layer/dist/utils/debug';
import { Layout, Spin, Typography, Col, Row } from 'antd';

import { t } from '../../config/translations';
import { OrderLineExtras } from '../../returns/views/OrderLineExtras';
import { formatDate } from '../../utils';
import { useOrder } from '../hooks';
import { orderLineSchema } from '../schemas';
import { OrderLine } from '../types';

// Register this component for debug tracking
debug.registerComponent('ViewOrder');

export type SearchOrderProps = {
  clientId?: string;
  orderId?: string;
  org: string;
  hideInfo?: boolean;
  suiviId?: string;
  isSuiviLoading?: boolean;
};

// Note: Error handling is done at the Show.tsx level with OrderNotFound component
// This component focuses on displaying data when available
const ViewOrder = (props: SearchOrderProps) => {
  debug.trackRender('ViewOrder');
  const { clientId, orderId, org, hideInfo = false, isSuiviLoading, suiviId } = props;
  debug.log('ViewOrder', `Rendering with orderId: ${orderId}, clientId: ${clientId}`);

  const { data, isLoading } = useOrder({ clientId, orderId });
  debug.log('ViewOrder', `Data loaded: ${!!data}, isLoading: ${isLoading}`);

  if (isLoading || isSuiviLoading)
    return (
      <Layout.Content>
        <div
          style={{
            width: '100%',
            height: 'max(100%, 256px)',
            minHeight: '256px',
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin tip={t('misc.loading')} />
        </div>
      </Layout.Content>
    );

  return (
    <Layout.Content>
      {data && (
        <>
          {!hideInfo && (
            <Row justify="center">
              <Col xs={24} style={{ marginTop: '24px' }}>
                <div
                  className="info-container"
                  style={{ width: 'fit-content', marginBottom: '12px' }}
                >
                  <Typography.Text
                    className="order-info-title"
                    style={{
                      fontWeight: '700',
                      fontSize: '18px',
                    }}
                  >
                    {t('order.yourOrderNumber')} {data?.ndoc}{' '}
                  </Typography.Text>
                  <Typography.Text>
                    {t('order.of')} <b>{formatDate(String(data?.dtac))}</b>{' '}
                  </Typography.Text>
                  <Typography.Text>
                    {t('order.totalTtc')} <b>{data?.mdtt} €</b>{' '}
                  </Typography.Text>
                  <Typography.Text>
                    | {t('order.status')}: <b>{data?.etat}</b>{' '}
                  </Typography.Text>
                </div>
              </Col>
            </Row>
          )}

          <List<OrderLine>
            data={data?.lignes?.ligne?.map((line: any) => ({
              ...line,
              student: data?.type === 'ECO',
              clientId,
              orderId,
            }))}
            loading={isLoading || isSuiviLoading}
            title={t('list.yourArticles')}
            subTitle={t('list.addItemsToReturn')}
            org={org}
            schema={orderLineSchema}
            idKey="desi"
            rowKey={(record: OrderLine) =>
              `${record?.nart}_${Math.random()}` || String(Math.random())
            }
            ExtraActions={!suiviId ? OrderLineExtras : undefined}
          />
        </>
      )}
    </Layout.Content>
  );
};

export default ViewOrder;

// Mark this component as initialized
debug.markInitialized('ViewOrder');
